import * as React from 'react'
import { Link } from 'react-router-dom'

import { TabsContext } from '../tabsContext'

import * as styles from './tab.module.css'

interface IProps {
  to: string
  children: React.ReactNode
}

const LinkTab = ({ children, to }: IProps) => (
  <TabsContext.Consumer>
    {({ tabsValue, onChange }) => {
      const isActive = tabsValue === to
      const activeStyle = isActive ? styles.active : ''
      return (
        <Link
          onClick={() => onChange(to)}
          className={`${styles.root} ${activeStyle}`}
          role="tab"
          aria-selected={isActive}
          to={to}
        >
          {children}
        </Link>
      )
    }}
  </TabsContext.Consumer>
)

export default LinkTab
